import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    paddingVertical: 4,
  },

  text: {
    backgroundColor: 'transparent',
  },
});



// WEBPACK FOOTER //
// ./src/components/third-party/Textfield/src/components/helper/styles.js